//@flow

import React, { useState } from 'react';
import { parse } from 'query-string';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormGroup, Label, Input, Container, Col, Row } from 'reactstrap';

import api from '../../../lib/api';
import SEO from '../../../constants/seo';
import Page from '../../../components/Page';
import Loading from '../../../components/Loading';
import endpoints from '../../../lib/endpoints';
import { PlaceCard } from '../../../components/Cards';
import { SCHEMA_ADD_PLACE_LISTINGS } from '../../../redux/actions/types';
import { useEffectOnFirstAndUpdateRender } from '../../../hooks';

type Props = {
  allPlaces: Array<Object>,
  fetchPlaces: (region: string) => void,
  location: { search: string },
  history: { push: (url: string) => void },
  region: string,
};

const DEFAULT_REGION_NAME = 'everest';

const sortPlaces = (places, sortType) => {
  if (sortType === 'default') return places;

  const placesWithAlt = places.filter(p => p.altitude);
  const placesWithoutAlt = places.filter(p => !p.altitude);

  return [...orderBy(placesWithAlt, 'altitude.meters', sortType), ...placesWithoutAlt];
};

export const fetchPlacesByRegion = region => async (dispatch, getState) => {
  const regionAlreadyInStore = getState().schema.placesList.allNames.includes(region);
  if (regionAlreadyInStore) return;

  const { data } = await api.get(endpoints.place.listings.withRegion(region));

  dispatch({
    type: SCHEMA_ADD_PLACE_LISTINGS,
    payload: { data, region },
  });
};

const mapStateToProps = ({ schema: { placesList } }, ownProps) => ({
  allPlaces: placesList.byName,
  region: parse(ownProps.location.search).region || DEFAULT_REGION_NAME,
});

const mapDispatchToProps = dispatch => ({
  fetchPlaces: region => dispatch(fetchPlacesByRegion(region)),
});

function PlaceListings(props: Props) {
  const [sortType, setSortType] = useState('default');
  const [searchTerm, setSearchTerm] = useState('');

  const { allPlaces, fetchPlaces, history, location, region } = props;

  useEffectOnFirstAndUpdateRender(
    () => {
      // the url can be '/places' too without the queryparams
      // to account for that especially on first render of the place
      // we need to construct the url
      if (!location.search) constructQuery(region);
      fetchPlaces(region);
    },
    [region]
  );

  const constructQuery = region => history.push(`?region=${region}`);

  if (isEmpty(props.allPlaces) || isEmpty(props.allPlaces[region])) return <Loading />;

  const places = sortPlaces(allPlaces[region], sortType);
  return (
    <Page {...SEO.placeListings}>
      <Container>
        <Row>
          <Col xl="2" lg="3" md="4" className="place-sidebar">
            <FormGroup>
              <Label for="searchTerm">Search</Label>
              <Input
                type="type"
                name="searchTerm"
                id="searchTerm"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="searchTerm">Region</Label>
              <div className="region-select">
                <select name="region" onChange={e => constructQuery(e.target.value)}>
                  <option value="everest" selected={'everest' === region}>
                    Everest Region
                  </option>
                  <option value="annapurna" selected={'annapurna' === region}>
                    Annapurna Region
                  </option>
                </select>
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="searchTerm">Sort</Label>
              <div className="region-select">
                <select name="sortType" onChange={e => setSortType(e.target.value)}>
                  <option value="default" selected={'default' === sortType}>
                    Default
                  </option>
                  <option value="desc" selected={'desc' === sortType}>
                    Altitude: High To Low
                  </option>
                  <option value="asc" selected={'asc' === sortType}>
                    Altitude: Low To High
                  </option>
                </select>
              </div>
            </FormGroup>
          </Col>

          <Col xl="10" lg="9" md="8">
            <Row>
              {places &&
                !isEmpty(places) &&
                places
                  .filter(
                    place =>
                      `${place.name}`.toUpperCase().indexOf(searchTerm.toUpperCase()) >= 0
                  )
                  .map(place => (
                    <Col xl="3" lg="4" md="6" key={place.id}>
                      <PlaceCard placeData={place} />
                    </Col>
                  ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Page>
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlaceListings)
);



// WEBPACK FOOTER //
// ./src/screens/Places/Listings/Listings.jsx